import { render } from "./CalendarEventAttendeeDetails.vue?vue&type=template&id=fbcddf22&scoped=true"
import script from "./CalendarEventAttendeeDetails.vue?vue&type=script&lang=ts"
export * from "./CalendarEventAttendeeDetails.vue?vue&type=script&lang=ts"

import "./CalendarEventAttendeeDetails.vue?vue&type=style&index=0&id=fbcddf22&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fbcddf22"

export default script